import React, { Component } from "react";
import {
  getLedgerTypes,
  deleteLedgerType,
  updateLedgerTypeStatus,
} from "../../services/visaLedgerTypeService";
import Pagination from "../common/pagination";
import { paginate } from "../../utils/paginate";
import TypesTable from "./typesTable";
import { toast } from "react-toastify";
import BlockUi from "react-block-ui";
import _ from "lodash";
import { Confirm } from "semantic-ui-react";
import auth from "../../services/authService";
import TopStatus from "../common/topStatus";
import ModuleFiltersSimple from "../common/moduleFiltersSimple";
import NotFound from "../common/notfound";

class VisaTypes extends Component {
  state = {
    open: false,
    type: "",
    types: [],
    pageSize: 10,
    currentPage: 1,
    keyFieldValue: "",
    sortColumn: { path: "title", order: "asc" },
    noRecordFound: "",
  };

  async componentDidMount() {
    document.body.style.backgroundImage = "none";
    this.setState({ blocking: true, show: "none" });
    const { data: types } = await getLedgerTypes(
      auth.getCurrentUser().company_id
    );
    this.checkTotalTypes(types);
    this.setState({ types, blocking: false });
  }

  checkTotalTypes = (types) => {
    if (types.length > 0) {
      this.setState({ show: "none" });
    } else {
      this.setState({ show: "block" });
    }
  };

  handleDelete = (type) => {
    this.setState({ open: true, type });
  };

  doDelete = async () => {
    const type = this.state.type;
    const originalTypes = this.state.types;
    const types = originalTypes.filter((o) => o.id !== type.id);
    this.setState({ types, open: false });

    try {
      await deleteLedgerType(type.id);
      this.checkTotalTypes(types);
      toast.success("Ledger type has been deleted successfully.");
    } catch (ex) {
      if (ex.response && ex.response.status === 404) {
        toast.success("This ledger type has already been deleted.");
      }

      this.setState({ types: originalTypes });
    }
  };

  handleUpdate = (type) => {
    return this.props.history.replace(
      "/visas-ledgers-types/" + type.id + "/edit"
    );
  };

  handlePageChange = (page) => {
    this.setState({ currentPage: page });
  };

  handleCancel = () => {
    this.setState({ open: false });
  };

  handleSearching = (keyword) => {
    this.setState({ keyFieldValue: keyword, currentPage: 1 });
  };

  handleSort = (sortColumn) => {
    this.setState({ sortColumn });
  };

  handleUpdateStatus = async (type) => {
    this.setState({ blocking: true });
    await updateLedgerTypeStatus(type);
    const { data: types } = await getLedgerTypes();

    this.setState({ blocking: false, types });
  };

  getPagedData = () => {
    const {
      pageSize,
      currentPage,
      types: allTypes,
      keyFieldValue,
      sortColumn,
    } = this.state;

    const filtered = keyFieldValue
      ? allTypes.filter(
          (m) => m.name.toUpperCase().indexOf(keyFieldValue.toUpperCase()) > -1
        )
      : allTypes;

    const sorted = _.orderBy(filtered, [sortColumn.path], [sortColumn.order]);

    const types = paginate(sorted, currentPage, pageSize);
    return { totalCount: filtered.length, data: types };
  };

  render() {
    const emtpyUrl = process.env.REACT_APP_URL + "/empty1.png";
    const { pageSize, currentPage, sortColumn, show } = this.state;
    const { totalCount, data: types } = this.getPagedData();
    const otherShow = show === "none" ? "block" : "none";
    const dashboardIcon = process.env.REACT_APP_URL + "/new_theme/visa.png";

    if (this.state.types.length === 0 && this.state.blocking === false) {
      return (
        <NotFound
          title="Ledger Types"
          linkTitle="Ledger Type"
          link="/visas-ledgers-types/new"
          button={true}
        />
      );
    }

    return (
      <BlockUi tag="div" blocking={this.state.blocking}>
        <Confirm
          open={this.state.open}
          header="Confirmation"
          content="Are you sure, you want to delete the type?"
          onCancel={this.handleCancel}
          onConfirm={this.doDelete}
          size="mini"
        />

        <h1 className="container__heading">Visas ledger types</h1>

        <article className="grid filters-simple">
          <ModuleFiltersSimple
            onSearchButtonClick={this.handleSearching}
            addLink="/visas-ledgers-types/new"
            addTitle="Ledger type"
          />
        </article>

        <TopStatus count={totalCount} module="Types" />

        <TypesTable
          types={types}
          sortColumn={sortColumn}
          onDelete={this.handleDelete}
          onUpdate={this.handleUpdate}
          onSort={this.handleSort}
          onStatusUpdate={this.handleUpdateStatus}
        />
        <Pagination
          itemsCount={totalCount}
          pageSize={pageSize}
          onPageChange={this.handlePageChange}
          currentPage={currentPage}
        />
      </BlockUi>
    );
  }
}

export default VisaTypes;
